import React from "react";
//Material Imports
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles"; //Limitless Imports

import { useNotificationContext } from "../../../common/hooks/notification/NotificationContext";
import { useTranslation } from "../../../common/hooks/translation/TranslationContext";
var useStyles = makeStyles(function (theme) {
  return {
    toastContainer: {
      background: theme.palette.contrast.main,
      display: "flex",
      animation: "$llmToastFadeIn 0.5s ease-in both",
      justifyContent: "space-between",
      position: "absolute",
      width: "100%",
      zIndex: 2
    },
    "@media screen and (max-width: 450px)": {
      toastContainer: {
        top: 56
      }
    },
    "@keyframes llmToastFadeIn": {
      from: {
        opacity: "0"
      },
      to: {
        opacity: "1"
      }
    },
    textColor: {
      color: theme.palette.contrast.light
    },
    text: {
      lineHeight: 1,
      paddingLeft: 24,
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      display: "flex",
      alignItems: "center"
    }
  };
});

var Toast = function Toast(_ref) {
  var headerSize = _ref.headerSize;
  var classes = useStyles();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useNotificationConte = useNotificationContext(),
      notification = _useNotificationConte.notification,
      clearNotification = _useNotificationConte.clearNotification;

  var handleDismiss = function handleDismiss() {
    clearNotification();
  };

  React.useEffect(function () {
    var autoDismissTimer;

    if (notification.title) {
      autoDismissTimer = setTimeout(clearNotification, 200000);
    }

    return function () {
      clearTimeout(autoDismissTimer);
    };
  }, [notification.title]);

  if (!notification.title) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.toastContainer,
    style: {
      top: headerSize
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: "".concat(classes.text, " ").concat(classes.textColor)
    }
  }, t(notification.title)), /*#__PURE__*/React.createElement(Button, {
    onClick: handleDismiss,
    className: classes.textColor
  }, t("Dismiss")));
};

export default Toast;
Toast.defaultProps = {
  headerSize: 63
};